import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  giftBagEide,
  editShopGift,
  getValidActivity,
  createThousandGift,
  editThousandGift,
  thousandGiftDetail,
  getGiftBagList,
  sellerImage,
  getSystemTemplateGroup,
  delSmartCardTemplate,
  deleteActivityList
} from "@/api/paradiseAndTaskCommonController.js";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      tempSwitchList: [{
        isVisible: true,
        title: '全部',
        id:-1,
      }],
      tempItem: {},
      tempIndex: 0,
      templateGroupId:0,
      tempTitle:'',
      isTemplateDialog:false,
      loading:false,
      giftList: [],
      activityData:{},
      temId:0,
      templateDialogType:'new',
      activityTypeList: [1, 8, 16, 17, 18, 19,34,35,32,37],// 8 16 17 18 35
      customUploadList:[ 8,16,17,18,35]
    }  
  },
  async created() {
      this.activityData = this.handleRouteType();
      const activityType = this.$route.query.activityType || this.copyParams.activityType
      if(!this.activityTypeList.includes(Number(activityType))) {
        this.giftList.push({
          ...this.activityData,
          templateExampleUrl: this.activityData.src,
          templateName: this.activityData.title,
          id: this.activityData.activityID,
        })
      }
      if(this.activityTypeList.includes(Number(activityType))) {
        this.getSystemTemplateGroup()
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
  methods: {
    // 模板分类
    getSystemTemplateGroup() {
      getSystemTemplateGroup({smartCardType: this.$route.query.activityType || this.copyParams.activityType}).then((res) => {
        if(res.data && res.data.length > 0) {
          res.data.map((item) => {
            item.title = item.groupName
            item.isVisible = true
          })
        }
        this.tempSwitchList.push(...res.data)
        this.sellerImage(-1, 0)
      })
    },

    // 模板
    sellerImage(templateGroupId, index,title) {
      this.tempIndex = index;
      this.templateGroupId=templateGroupId
      this.tempTitle = title;
      const activityType = this.$route.query.activityType || this.copyParams.activityType
      if(!this.activityTypeList.includes(Number(activityType))) {
        return
      }
      this.loading = true;
      sellerImage({
        current: 1,
        size: 1000,
        source: 3,
        type: 1,
        smartCardType: Number(this.$route.query.activityType || this.copyParams.activityType),
        templateGroupId: templateGroupId != -1 ? templateGroupId : "",
      }).then((res) => {
        res.data.records.map((item) => {
          item.templateId = item.id
        })
        this.giftList = res.data.records.map((item) => ({
          ...item,
          ...this.activityData,
          id: this.activityData.activityID,
          days: item.validTimeType
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        }));
        this.$nextTick(() => {
          this.getCodeIMGList();
        });
        this.loading = false;
      })
    },

      handleRouteType() {
        let activityType = this.$route.query.activityType * 1 || this.copyParams.activityType;
        let data = {};
        switch (activityType) {
          case 1:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "签到领好礼";
            data.content = "支持每日签到、连续签到、累计签到多种赠送方式，增强会员粘性";
            data.src = require("../assets/thdImg/cover/qdq.png");
            data.bghome = require("../assets/thdImg/cover/bg_qdq.svg");
            data.path = 'activity'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D23%26activityType%3D1%26target%3DTask_EveryDaySign'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/gindog'
            break;
          case 2:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "每日抢好礼";
            data.content = "限时限量发放好礼，制造紧迫感，吸引会员定时参与店铺活动";
            data.src = require("../assets/thdImg/cover/mrq.png");
            data.bghome = require("../assets/thdImg/cover/bg_mrq.svg");
            data.path = 'activity'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D24%26activityType%3D3%26target%3DrobGoodPresent'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/gpt3d3'
            break;
          case 3:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "关注店铺有礼";
            data.content = "关注店铺赢好礼，可增加店铺关注量，提升店铺权重，支持设置曝光商品，刺激转化提客户粘性，推广店铺必推玩法";
            data.src = require("../assets/thdImg/cover/gzdp.png");
            data.bghome = require("../assets/thdImg/cover/bg_gzdp.svg");
            data.path = 'activity'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D25%26activityType%3D4%26target%3DattentionShop'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/tr3rpe'
            break;
          case 4:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "邀请开卡有礼";
            data.content = "引导客户邀请好友开卡，迅速增加活动曝光率，提升店铺流量，提升转化率";
            data.src = require("../assets/thdImg/cover/kk.png");
            data.bghome = require("../assets/thdImg/cover/bg_kk.svg");
            data.path = 'Invites'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D27%26activityType%3D5%26target%3DinviteCard'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/ak0nwr'
            break;
          case 5:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "邀请关注店铺有礼";
            data.content = "引导客户邀请好友关注店铺，迅速增加活动曝光率，提升店铺流量，提升转换率";
            data.src = require("../assets/thdImg/cover/yqgz.png");
            data.bghome = require("../assets/thdImg/cover/bg_yqgz.svg");
            data.path = 'activity'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D26%26activityType%3D6%26target%3Dinvite'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/bxml1q'
            break;
          case 6:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "完善信息有礼";
            data.content = "收集店铺会员信息，提交后赠送礼品，完善店铺会员标签";
            data.src = require("../assets/thdImg/cover/wsxx.png");
            data.bghome = require("../assets/thdImg/cover/bg_wsxx.svg");
            data.path = 'activity'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D28%26activityType%3D7%26target%3Dperfect_information'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/zqw11z'
            break;
          // case 13:
          //   data.activityID = activityType;
          //   data.title = "开卡礼包";
          //   data.content = "开卡礼包支持针对会员和非会员人群跳转链接设置";
          //   data.src = require("../assets/images/integralCenter/icon_kakai.png");
          //   break;
          // case 15:
          //   data.activityID = activityType;
          //   data.title = "店铺礼包千人千面";
          //   data.content = "店铺礼包可以选择目标人群，定向投放，礼品支持京券、东券、京豆、积分";
          //   data.src = require("../assets/images/integralCenter/icon_qrqm.png");
          //   break;
          case 8:
            data.activityID = activityType;
            data.secondaryMenuName = "趣味抽奖";
            data.title = "幸运大抽奖";
            data.content = "缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度";
            data.src = require("../assets/thdImg/cover/dzp.png");
            data.bghome = require("../assets/thdImg/cover/bg_dzp.svg");
            data.imgList= [
            require("@/assets/thdImg/home/hot_dzp.svg"),
            require("@/assets/thdImg/home/hot_jgg.svg"),
          ],
            data.path = 'step'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D36%26activityType%3D8%26target%3DbigTurntable'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/dyme2n'
            break;
          case 16:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "下单有礼";
            data.content = "通过下单有礼权益，商家可对会员进行下单奖励，从而有效的提升会员转化、复购率。";
            data.src = require("../assets/thdImg/cover/xdyl.png");
            data.bghome = require("../assets/thdImg/cover/bg_xdyl.svg");
            data.path = 'polite'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D33%26activityType%3D16%26target%3Dordergift'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/xagbao'
            break;
          case 17:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "首购有礼";
            data.content = "通过首购有礼权益，商家可对会员进行首购奖励，从而有效的提升会员转化、复购率。";
            data.src = require("../assets/thdImg/cover/sgyl.png");
            data.bghome = require("../assets/thdImg/cover/bg_sgyl.svg");
            data.path = 'polite'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D31%26activityType%3D17%26target%3Dordergift'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/yy11ug'
            break;
          case 18:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "复购有礼";
            data.content = "通过复购有礼权益，商家可对会员进行复购奖励，从而有效的提升会员转化、复购率。";
            data.src = require("../assets/thdImg/cover/fgyl.png");
            data.bghome = require("../assets/thdImg/cover/bg_fgyl.svg");
            data.path = 'polite'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D32%26activityType%3D18%26target%3Dordergift'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/ayizzp'
            break;
          case 19:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "下单抽奖";
            data.content = "通过下单抽奖权益，商家可对会员进行下单奖励，根据奖项的不同可以设置不同的中奖概率，有效提高用户的参与积极性从而提升会员转化。";
            data.src = require("../assets/thdImg/cover/xdcj.png");
            data.bghome = require("../assets/thdImg/cover/bg_xdcj.svg");
            data.path = 'step2'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D35%26activityType%3D19%26target%3DplaceOrder'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/uoulb6'
            break;
          // case 20:
          //   data.activityID = activityType;
          //   data.title = "评价有礼";
          //   data.content = "通过礼品激励买家进行评价，买家好评后可参与抽奖赢取礼品，快速提升店铺DSR";
          //   data.src = require("../assets/images/integralCenter/icon_pjyl.png");
          //   data.bghome = require("../assets/thdImg/cover/bg_xdcj.png");
          //   data.path = 'evaluation'
          //   break;
          case 21:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "裂变神券";
            data.content = "通过社交分享，邀请好友组团领券，成功裂变涨粉";
            data.src = require("../assets/thdImg/cover/lbsq.png");
            data.bghome = require("../assets/thdImg/cover/bg_lbsq.svg");
            data.path = 'evaluation'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D30%26activityType%3D21%26target%3DgroupCoupon'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/kf4gu3'
            break;
          case 22:
            data.activityID = activityType;
            data.secondaryMenuName = "关注拉粉";
            data.title = "天降红包雨";
            data.content = "倒计时接红包，根据接红包的个数获得奖品，活跃店铺气氛";
            data.src = require("../assets/thdImg/cover/tjhby.png");
            data.bghome = require("../assets/thdImg/cover/bg_tjhby.svg");
            data.path = 'evaluation'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D29%26activityType%3D22%26target%3DredPacketRain'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/yyshm8'
            break;
          case 23:
            data.activityID = activityType;
            data.secondaryMenuName = "游戏中心";
            data.title = "疯狂抓娃娃";
            data.content = "新奇趣味的在线抓娃娃游戏，玩游戏的同时赢取礼品，增加客户留存以及提升客户的粘性";
            data.src = require("../assets/thdImg/cover/zww.png");
            data.bghome = require("../assets/thdImg/cover/bg_zww.svg");
            data.path = 'games'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D37%26activityType%3D23%26target%3DcatchDoll'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/hv4naq'
            break;
          case 24:
            data.activityID = activityType;
            data.secondaryMenuName = "游戏中心";
            data.title = "大家来找茬";
            data.content = "“大家来找茬”是一款热门休闲的游戏，在限定时间内，找出两幅图的不同之处，通关后即可参与抽奖赢取礼品";
            data.src = require("../assets/thdImg/cover/zc.png");
            data.bghome = require("../assets/thdImg/cover/bg_zc.svg");
            data.path = 'games'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D38%26activityType%3D24%26target%3DseekDistinct'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/iqcazq'
            break;
          case 25:
              data.activityID = activityType;
              data.secondaryMenuName = "关注拉粉";
              data.title = "入会打榜";
              data.content = "通过社交分享，邀请好友入会，根据邀请排名榜发放奖品";
              data.src = require("../assets/thdImg/cover/入会打榜@2x.png");
              data.bghome = require("../assets/thdImg/cover/入会打榜.svg");
              data.path = 'games'
              data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D144%26activityType%3D25%26target%3DjoinAndRank'
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/mdnmh0'
              break;  
          case 26:
              data.activityID = activityType;
              data.secondaryMenuName = "关注拉粉";
              data.title = "幸运抽签";
              data.content = "通过完成入会、关注等任务，获取抽奖数字，到开奖后公布中奖数字获取奖品";
              data.src = require("../assets/thdImg/cover/幸运抽签@2x.png");
              data.bghome = require("../assets/thdImg/cover/幸运抽签.svg");
              data.path = 'luckyDraw'
              data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D448%26activityType%3D26%26target%3DluckyLottery'
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/sab642'
              break;   
          case 27:
              data.activityID = activityType;
              data.secondaryMenuName = "关注拉粉";
              data.title = "0元试用";
              data.content = "邀请用户来报名试用，抽取其中的部分用户来发放使用商品";
              data.src = require("../assets/thdImg/cover/0元试用@2x.png");
              data.bghome = require("../assets/thdImg/cover/0元试用.svg");
              data.path = 'trial'
              data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D416%26activityType%3D27%26target%3DfreeTryOut'
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/cragkqxp42grhnp2'
              break;     
          case 31:
              data.activityID = activityType;
              data.secondaryMenuName = "无线营销";
              data.title = "调查问卷";
              data.content = "自定义问卷内容，快速收集用户反馈，更加了解消费者";
              data.src = require("../assets/thdImg/cover/调查问卷.png");
              data.bghome = require("../assets/thdImg/cover/调查问卷.svg");
              data.path = 'question'
              data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D552%26activityType%3D31%26target%3Dquestionnaire'
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/ygdoxc4bizeuggw2'
              break;
          case 32:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "生日有礼";
            data.content = "用户登记生日后，在生日时可以领取生日特权礼物";
            data.src = require("../assets/thdImg/cover/生日有礼.png");
            data.bghome = require("../assets/thdImg/cover/生日有礼.svg");
            data.path = 'birthday'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D546%26activityType%3D32%26target%3DbirthdayGift%26mode%3Dtest'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/ufmgxtey2xga45hi'
            break;
          case 33:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "积分兑换";
            data.content = "通过积分兑换实物、专属下单奖品内容";
            data.src = require("../assets/thdImg/cover/积分兑换.png");
            data.bghome = require("../assets/thdImg/cover/积分兑换.svg");
            data.path = 'exchange'
            data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D547%26activityType%3D33%26target%3DpointExchange'
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/ceekbgr7laeggbge'
            break;
          case 34:
              data.activityID = activityType;
              data.secondaryMenuName = "无线营销";
              data.title = "满额有礼";
              data.content = "通过设置多个金额阶梯，满指定金额可获得奖品，引导用户下单购买达标领取阶梯礼，有效提升用户下单付款转化率";
              data.src = require("../assets/thdImg/cover/满额有礼.png");
              data.bghome = require("../assets/thdImg/cover/满额有礼.png");
              data.path = 'fulfilQuotaPage'
              data.codeUrl = 'https://m.duanqu.com/?_ariver_appid=3000000077493601&_mp_code=tb&transition=present&query=sellerId%3D3175164588%26activityId%3D1373%26activityType%3D34%26target%3DfulfilQuota'
              // data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/rca8psx8n31o6iay?singleDoc# 《4.9满额有礼》'
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/rca8psx8n31o6iay'
            break;
          case 35:
            data.activityID = activityType;
            data.secondaryMenuName = "无线营销";
            data.title = "下单冲榜";
            data.content = "可对用户进行下单奖励设置，根据名次的不同可以设置对应的奖品，引导用户下单进而领取对应奖品，有效提升用户下单付款转化率";
            data.src = require("@/assets/thdImg/cover/xdcb.png");
            data.bghome = require("@/assets/thdImg/cover/xdcb.png");
            data.path = 'orderRankPage'
            data.codeUrl = `https://m.duanqu.com/?_ariver_appid=3000000077493601&_mp_code=tb&transition=present&query=sellerId%3D3175164588%26activityId%3D1609%26activityType%3D35%26target%3DorderRank`
            data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/qtafmguqy6m2niwm'
            break;
          case 37:
              data.activityID = activityType;
              data.secondaryMenuName = "无线营销";
              data.title = "会员升级礼";
              data.content = "可对用户进行下单奖励设置，根据名次的不同可以设置对应的奖品，引导用户下单进而领取对应奖品，有效提升用户下单付款转化率";
              data.src = require("@/assets/thdImg/cover/sjl.png");
              data.bghome = require("@/assets/thdImg/cover/sjl.png");
              data.path = 'memberUpgrade'
              data.codeUrl = `https://m.duanqu.com/?_ariver_appid=3000000077493601&_mp_code=tb&transition=present&query=sellerId%3D3175164588%26activityId%3D2061%26activityType%3D37%26target%3DmemberUpgradeGift`
              data.toUrl = 'https://www.yuque.com/yunduanxincrm/sd6oeu/dwp0d1th6pqcggry?singleDoc# 《4.11会员升级礼》'
              break
        }
        return data;
      },
        handleTem(item, index) {
          console.log(item,99999666);
          this.tempIndex = index;
          this.tempItem = item;
          this.getPolite();
        },
        // 店铺礼包千人千面数据初始化 // 获取模板
        async getPolite() {
            this.loading = true;
            // 开卡礼包版本
            const { data } = await getGiftBagTemplate({ dirId: this.tempItem.id });
            const giftList = data.map((item) => ({
                ...item,
                days: item.expirationType == 1 ? this.getDaysBetween(item.expirationStartDate, item.expirationEndDate) : "",
            }));
            this.giftList = giftList.filter((i) => i.giftType == 2);
            this.$nextTick(() => {
                this.getCodeIMG();
            });
            this.loading = false;
        },
        // 使用此模板
        handleSet(item,index) {
          console.log(item)
          let params = {
                activityData: {
                  name: item.title,
                  id: item.id,
                  telCode: '',
                  goIndex:index,
                  templateId: item.templateId,
                },
            };
          if (this.copyParams && this.copyParams.isCopy) {
            params.copyParams = this.copyParams
          }
          this.$router.push({ path: item.path, query: params });
          // let params = {
          //           activityData: {
          //             name: item.title,
          //             id: item.id,
          //             telCode:'',
          //           },
          //           data:{...item}
          //       };
          //     this.$router.push({ path: "activity", query: params });
        },
        //千人千面
      nextStepKai(items) {
        // console.log(item);
        //新增判断
        getValidActivity().then((res) => {
          // if (res.data) {
          //   const message =
          //     "当前正在进行【" +
          //     res.data[0].activityName +
          //     "】活动" +
          //     res.data[0].activityStartTime +
          //     "~" +
          //     res.data[0].activityEndTime +
          //     "，必须结束后才能新建！";
          //   this.$message.warning(message);
          //   return;
          // }
          let params = {
            activityData: {
              name: item.title,
              id: item.id,
              telCode: '',
            },
            data: { ...items }
          };
          this.$router.push({ path: "activity", query: params });
          // this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
          // 1 店铺积分  2 京豆  3  京券  4  东券
          //   const prizeType = items.prizeType ? items.prizeType.split(",") : [];
          //   // this.awardNumLimit = items.awardNumLimit //Tag: wk
          //   this.sceneList.forEach((i) => {
          //     i.templateNum = prizeType.length;
          //     i.templateUrlimg = items.templateUrl;
          //     i.giftTemplateId = items.id;
          //     i.awardNumLimit = items.awardNumLimit;
          //     prizeType.forEach((ele) => {
          //       if (ele == 1) {
          //         i.jfshow = true;
          //       }
          //       if (ele == 2) {
          //         i.jdshow = true;
          //       }
          //       if (ele == 3) {
          //         i.jqshow = true;
          //       }
          //       if (ele == 4) {
          //         i.dqshow = true;
          //       }
          //     });
          //   });
          //   this.$emit("titopName", this.activityData.name, true);
          });
          // this.Fun_jingdouAccount()
        },
        // 品牌定制弹窗
        handleOpen() {
          const href = "https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=%E7%BE%8E%E6%BB%B4%E7%94%9F%E6%B4%BB&site=cntaobao";
          window.open(href, "_self");
        },
        // 打开模板配置弹窗
        handleTemDialog(type,item){
          this.templateDialogType = type;
          console.log("item",item)
          if(!item){
            this.temId = 0
          }else{
            this.temId = item.templateId
          }
          this.isTemplateDialog = true;
        },
        //保存关闭模板
        saveTemplate(){
          this.isTemplateDialog = false;
          this.sellerImage(this.templateGroupId,this.tempIndex,'自定义上传')
        },
        //删除模板
        deleteTemDialog(item){
          this.$confirm(`是否确定删除`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log("确认删除")
            delSmartCardTemplate(item.templateId).then((res) => {
              if(res && res.code == 200){
                this.$message.success("删除成功")
                this.sellerImage(this.templateGroupId,this.tempIndex,'自定义上传')
              }
            })

            
          }).catch(() => {
          });
          console.log("item.templateId",item)

        },

        getCodeIMGList() {
          const url1 = this.activityData.codeUrl;
          if (this.$refs.QRcode_img) {
              this.$refs.QRcode_img.innerHTML = "";
          
              new QRCode('QRcode_img', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 140, // 设置宽度，单位像素
                height: 140, // 设置高度，单位像素
                // text: url1, // 设置二维码内容或跳转地址
                text: url1,
              });
          }
          if (this.$refs.qrCodeIMG) {
            this.$refs.qrCodeIMG.innerHTML = "";
            new QRCode('qrCodeIMG', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 140, // 设置宽度，单位像素
                height: 140, // 设置高度，单位像素
                // text: url1, // 设置二维码内容或跳转地址
                text: url1,
            });
          }
          const codeImg = document.querySelectorAll(".qrCodeIMG");
          for (let index = 0; index < codeImg.length; index++) {
            const elementbox = codeImg[index];
            elementbox.innerHTML = "";
          }
          const url = "https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26target%3DpreviewPage%26imageUrl="
          console.log(this.$route.query.activityType,'5454545565');
          // const url = "https://market.m.taobao.com/app/miniapp-biz/qrcode/index.html?_ariver_appid=3000000073929825&nbsv=0.1.93&_mp_code=tb&nbsource=debug&nbsn=TRIAL&transition=present&query=sellerId%3D2333763673%26target%3DpreviewPage%26imageUrl="
          for (let index = 0; index < codeImg.length; index++) {
            const element = codeImg[index];
            new QRCode(element, {
              width: 140, // 设置宽度，单位像素
              height: 140, // 设置高度，单位像素
              // text: url, // 设置二维码内容或跳转地址
              text:url + (this.$route.query.activityType==37 || this.copyParams.activityType == 37 ? this.giftList[index].eightPictureUrl:this.giftList[index].fourPictureUrl),
            });
          }
        },

        // 生成二维码
        getCodeIMG() {
          const url = this.activityData.codeUrl;
          if (this.$refs.QRcode_img) {
              this.$refs.QRcode_img.innerHTML = "";
          
              new QRCode('QRcode_img', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 140, // 设置宽度，单位像素
                height: 140, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
              });
          }
          if (this.$refs.qrCodeIMG) {
            this.$refs.qrCodeIMG.innerHTML = "";
             new QRCode('qrCodeIMG', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 140, // 设置宽度，单位像素
                height: 140, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
            });
          }

    },
        // 生成二维码
    getCodeIMG1() {
          
            // const codeImg = document.querySelectorAll(".qrCodeIMG");
          const url = this.activityData.codeUrl;
            new QRCode('qrCodeIMG1', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 140, // 设置宽度，单位像素
                height: 140, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
            });
        },
        // 限免日期
        getDaysBetween(dateString1, dateString2) {
            const startDate = Date.parse(dateString1);
            const nowDate = Date.parse(new Date());
            const endDate = Date.parse(dateString2);
            if (startDate > endDate) {
                return 0;
            }
            if (startDate == endDate) {
                return 1;
            }
            let days = 0;
            if (nowDate > startDate) {
                days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
            } else {
                days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            }
            return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
        },

    }
}